<template>
  <div>
    <list
      row-key="RecordId"
      ref="list"
      unit="商家信息"
      :page="page"
      :query-params="params"
      :show-checkbox="$permission.canDel()"
      :show-query="showQuery"
      :get-data-func="api.list"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="商家名称">
          <el-input
            v-model="params.BusiName"
            placeholder="请输入商家名称"
            clearable
          />
        </el-form-item>

        <el-form-item label="联系电话">
          <el-input
            v-model="params.ContactPhone"
            placeholder="请输入联系电话"
            clearable
          />
        </el-form-item>
        <el-form-item label="审核状态">
          <el-select
            v-model="params.CheckState"
            placeholder="请选择审核状态"
            clearable
            @change="changeState"
          >
            <el-option :value="1" label="待审"></el-option>
            <el-option :value="2" label="审核通过"></el-option>
            <el-option :value="3" label="审核不通过"></el-option>
          </el-select>
        </el-form-item>
      </template>
      <template slot="table">
        <!-- <el-table-column
          prop="OrderId"
          label="序号"
          width="60"
          align="center"
        /> -->
        <el-table-column prop="BusiCode" label="商家编号" />
        <el-table-column prop="BusiName" label="商家名称" />
        <el-table-column prop="RegTime" label="注册时间">
          <template slot-scope="{ row }">
            {{ row.RegTime }}
          </template>
        </el-table-column>
        <el-table-column prop="ContactName" label="联系人" />
        <el-table-column prop="ContactPhone" label="联系电话" />
        <el-table-column prop="Rate" label="平台分佣（%）" />

        <el-table-column prop="CheckState" label="审核状态">
          <template slot-scope="{ row }">
            <span v-if="row.CheckState == 1">待审</span>
            <span v-if="row.CheckState == 2">审核通过</span>
            <span v-if="row.CheckState == 3">审核不通过</span>
          </template>
        </el-table-column>
        <el-table-column prop="CheckMsg" label="审核结果" />
        <el-table-column
          prop="DataSource"
          align="center"
          label="数据来源"
          width="100"
        >
          <template slot-scope="{ row }">
            {{ row.DataSource == 1 ? "小程序申请" : "后台添加" }}
            <!--内容不需要显示样式或图标的，只显示数据的，则直接用这句话即可-->
          </template>
        </el-table-column>

        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";

export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      api: require("@/api/shop/business").default,

      params: {
        BusiName: "",

        ContactPhone: "",

        DataSource: 1,
        CheckStates: [1, 3],
        IsCheckStateSort: 1,
      },
    };
  },
  beforeMount() {},
  mounted() {
    if (this.$route.query.state == 1) {
      this.params.CheckState = 1;
      this.query(this.params);
    }
  },
  methods: {
    changeState(val) {
      this.params.CheckState = val;
      if (val == null||val=="") {
        this.params.CheckStates = [1, 3];
      } else {
        this.params.CheckStates = [val];
      }
      this.query(this.params);
    },
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>
